export default "__VITE_ASSET__CM$m2OHg__"